<template>
    <transition appear enter-active-class="animated bounceInRight">
        <f7-view main>
            <f7-page>
                <!-- header -->
                <cm-navbar :title="$ml.get('transferCovers')">
                    <f7-nav-right><f7-link @click="save">{{ $ml.get('save') }}</f7-link></f7-nav-right>
                </cm-navbar>
                <!-- END header -->

                <!-- body -->
                <f7-list inline-labels no-hairlines-md>
                    <f7-list-item :title="$ml.get('cover')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true, searchbar: true}">
                        <select name="cover_id" v-model="form.cover_id" v-validate="'required'">
                            <option v-for="item in covers" :value="item.id" :key="item.id">{{ item.name }}</option>
                        </select>
                    </f7-list-item>

                    <!-- <f7-list-item :title="$ml.get('inventoryPlace')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true,}">
                        <select name="inventory_id" v-model="form.inventory_id" v-validate="'required'">
                            <option v-for="item in inventories" :value="item.id" :key="item.id">{{ item.name }}</option>
                        </select>
                    </f7-list-item> -->

                    <f7-list-input type="number" :label="$ml.get('amount')" placeholder="0" clear-button :value="form.amount" @input="form.amount = $event.target.value" name="amount" v-validate="'required'"></f7-list-input>

                    <f7-list-input type="text" :label="$ml.get('solo')" clear-button :value="form.solo" @input="form.solo = $event.target.value" name="solo"></f7-list-input>
                    <f7-list-input type="number" :label="$ml.get('price')" clear-button :value="form.price" @input="form.price = $event.target.value" name="price"></f7-list-input>

                    <f7-list-item :title="$ml.get('supplier')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true, searchbar: true}">
                        <select name="supplier_id" v-model="form.supplier_id" v-validate="'required'">
                            <option v-for="item in suppliers" :value="item.id" :key="item.id">{{ item.name }}</option>
                        </select>
                    </f7-list-item>
                </f7-list>
                <!-- END body -->
            </f7-page>
        </f7-view>
    </transition>
</template>

<script>
    import Query    from '@/services/api/Query'
    import Mutation from '@/services/api/Mutation'
    import CMNavbar from './Navbar'

    export default {
        name: 'FormAddInventoryCover',
        props: {},
        components: {
            'cm-navbar': CMNavbar,
        },
        data() {
            return {
                form: {
                    solo:         null,
                    price:        null,
                    amount:       null,
                    cover_id:     null,
                    inventory_id: null,
                    supplier_id:  null,
                },
                covers: [],
                suppliers: [],
                // inventories: [],
            }
        },
        methods: {
            resetForm() {
                this.form = {
                    solo:         null,
                    price:        null,
                    amount:       null,
                    cover_id:     null,
                    inventory_id: null,
                    supplier_id:  null,
                }
                this.$helper.clearAll()
            },

            async save() {
                if (! await this.$validator.validateAll())
                    return this.$f7.dialog.alert(this.$ml.get('errors.requiredAll'), this.$ml.get('errors.title'))

                this.$f7.dialog.preloader(this.$ml.get('processing'))
                let result = await Mutation
                    .transferCovers(this.form)
                    .execute()

                /* check & show error */
                if (result.data.errors) {
                    this.$f7.dialog.close()
                    let message = this.$helper.errors(result.data.errors)

                    return this.$f7.dialog.alert(message, this.$ml.get('errors.title'))
                }

                this.$f7.dialog.close()
                return this.$f7.dialog.alert(
                    this.$ml.get('success.transferCovers'),
                    this.$ml.get('information'),
                    () => this.resetForm()
                )
            },
        },

        async created() {
            let formData   = await Query
                .withCovers(null, null, null)
                .withSuppliers()
                // .withInventories()
                .get()

            this.covers = this.$helper.data(formData, 'covers')
            this.suppliers = this.$helper.data(formData, 'suppliers')
            // this.inventories = this.$helper.data(formData, 'inventories')
        },
    }
</script>